import React, { Component } from "react";
import { invokeApig } from '../../libs/awsLib';
import { Glyphicon, Button, Col, Badge } from "react-bootstrap";
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import '../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import PersonActions from './PersonActions';

export default class ListPersons extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            isMoreLoading: false,
            persons: [],
            refresh: false
        };
    }

    componentDidMount() {
    	this.updateTable();
    }
    componentWillReceiveProps(props) {
    	if (props.update !== this.props.update) {
    		this.updateTable();
    	}
    }
    updateTable = async () => {
    	this.setState({ isLoading: true, persons: [], lastId: null });
		this.persons().then((response) => {
			this.setState({ ...response, persons: response.Items, isLoading: false });
		}, (error) => {
			alert(error);
        	this.setState({ isLoading: false });
        });
    }

    setTableOption() {
    	if (this.state.isLoading) {
    	  return <div><Glyphicon glyph="refresh" className="spinning" />Cargando datos... por favor espere</div>;
	    } else {
	      return "No hay datos";
	    }
    }

    persons() {
        return invokeApig({
            path: "/person/find",
            method: "POST",
            body: {
                "page": 0,
                "size": 10
            }
        });
    }
/*
    persons(lastId) {
        return invokeApig({
            path: "/person/find",
            method: "POST",
            body: lastId
        });
    }
*/
    handleAlertSuccess = (message) => {
      this.props.onAlertSuccess(message);
      this.setState({ isLoading: true });
      this.componentDidMount();
    }
    handleAlertError = (message) => {
      this.props.onAlertError(message);
    }

    personFormatter = (cell, row) => {
        return(
            //<Link to={{ pathname:"/support/detail", state: row }}>{cell}</Link>
            <PersonActions className="actions" {...this.props} personId={row.original.id} onAlertSuccess={this.handleAlertSuccess} onAlertError={this.handleAlertError}/>
        )
    }

    handleMore = async () => {
    	this.setState({ isMoreLoading: true });
    	try {
        	let results = await this.persons({ lastId: this.state.lastId });
        	var persons = this.state.persons.slice();
        	results.persons = persons.concat(results.persons);
            this.setState({ ...results, isMoreLoading: false });
        } catch (e) {
        	alert(e);
        	this.setState({ isMoreLoading: false });
        }
    }

    render(){

        const selectRowProp = {
            mode: 'radio',
            bgColor: 'pink', // you should give a bgcolor, otherwise, you can't regonize which row has been selected
            hideSelectColumn: true,  // enable hide selection column.
            clickToSelect: true,  // you should enable clickToSelect, otherwise, you can't select column.
            onSelect: this.onRowSelect,
          };
          const tableOptions = {
              noDataText: this.setTableOption()
          };
          const data = this.state.persons;
        return(
            <div>
            <Col sm={4} className="update">
	      		<Button onClick={this.updateTable} className="btnRefresh">
	      			<Glyphicon glyph="refresh" />
	      		</Button>
	      	</Col>
            <Col sm={12} className="persons">
        	<BootstrapTable data={ data } selectRow={ selectRowProp } options={tableOptions}>
                <TableHeaderColumn dataField='documentId' filter={ { type: 'TextFilter', delay: 10 } } isKey >RUN</TableHeaderColumn>
                <TableHeaderColumn dataField='name' filter={ { type: 'TextFilter', delay: 10 } }  dataSort={ true }>Nombre</TableHeaderColumn>
                <TableHeaderColumn dataField='email' filter={ { type: 'TextFilter', delay: 10 } }  dataSort={ true }>Correo</TableHeaderColumn>
                <TableHeaderColumn dataField='creationDate' filter={ { type: 'TextFilter', delay: 10 } } dataSort={ true }>Fecha de creación</TableHeaderColumn>
                <TableHeaderColumn ref='statusCol' dataField='status' filter={ { type: 'TextFilter', delay: 10 } } dataSort={ true }>Estado</TableHeaderColumn>
                <TableHeaderColumn dataSort={ true } /*dataFormat={ this.personFormatter }*/>Acciones</TableHeaderColumn>
            </BootstrapTable>
            {
            	this.state.lastId && (this.state.isMoreLoading ? <div><Glyphicon glyph="refresh" className="spinning" />Cargando más tickets...</div> : <div><Button onClick={this.handleMore} className="loadMore">Cargar más...</Button></div>)
            }
            </Col>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/person/ListPersons.js